import React from "react";
import { useGetPriorityMap } from "security-app/hooks/useAssetsAPI";
import { RiskScoreBadge } from "security-app/components/common";
import VulnerabilitiesCount from "security-app/components/Assets/AssetDetails/VulnerabilitiesCount";
import { COLUMN_WIDTH } from "components/common/EntityDataTable/Constants";
import AssetNameCell from "./AssetNameCell";
const LIST_COLUMN_WIDTH = 200;
const PriorityCellRenderer = ({ priority }) => {
  var _a;
  const { priorityMap } = useGetPriorityMap();
  if (!priority) return null;
  return /* @__PURE__ */ React.createElement("span", null, (_a = priorityMap[priority]) != null ? _a : priority);
};
const commonColumnRenderers = {
  attributes: {
    name: {
      staticWidth: COLUMN_WIDTH.title,
      renderCell: (_name, asset) => /* @__PURE__ */ React.createElement(AssetNameCell, { asset })
    },
    priority: {
      staticWidth: 100,
      renderCell: (priority) => /* @__PURE__ */ React.createElement(PriorityCellRenderer, { priority })
    },
    category: {
      staticWidth: LIST_COLUMN_WIDTH,
      renderCell: (category) => /* @__PURE__ */ React.createElement("span", null, category == null ? void 0 : category.join(", "))
    }
  }
};
const machineColumnRenderers = {
  attributes: {
    ...commonColumnRenderers.attributes,
    hostnames: {
      staticWidth: LIST_COLUMN_WIDTH,
      renderCell: (hostnames) => /* @__PURE__ */ React.createElement("span", null, hostnames == null ? void 0 : hostnames.join(", "))
    },
    ip_addresses: {
      staticWidth: LIST_COLUMN_WIDTH,
      renderCell: (ip_addresses) => /* @__PURE__ */ React.createElement("span", null, ip_addresses == null ? void 0 : ip_addresses.join(", "))
    },
    mac_addresses: {
      staticWidth: LIST_COLUMN_WIDTH,
      renderCell: (mac_addresses) => /* @__PURE__ */ React.createElement("span", null, mac_addresses == null ? void 0 : mac_addresses.join(", "))
    },
    risk_score_normalized: {
      staticWidth: 100,
      renderCell: (risk_score_normalized) => /* @__PURE__ */ React.createElement(RiskScoreBadge, { riskScore: risk_score_normalized })
    },
    vulnerabilities: {
      staticWidth: 150,
      renderCell: (vulnerabilities) => /* @__PURE__ */ React.createElement(VulnerabilitiesCount, { vulnerabilities })
    }
  }
};
const userColumnRenderers = {
  attributes: {
    ...commonColumnRenderers.attributes,
    usernames: {
      staticWidth: LIST_COLUMN_WIDTH,
      renderCell: (usernames) => /* @__PURE__ */ React.createElement("span", null, usernames == null ? void 0 : usernames.join(", "))
    },
    user_ids: {
      staticWidth: LIST_COLUMN_WIDTH,
      renderCell: (user_ids) => /* @__PURE__ */ React.createElement("span", null, user_ids == null ? void 0 : user_ids.join(", "))
    },
    email_addresses: {
      staticWidth: LIST_COLUMN_WIDTH,
      renderCell: (email_addresses) => /* @__PURE__ */ React.createElement("span", null, email_addresses == null ? void 0 : email_addresses.join(", "))
    },
    risk_score_normalized: {
      staticWidth: 100,
      renderCell: (risk_score_normalized) => /* @__PURE__ */ React.createElement(RiskScoreBadge, { riskScore: risk_score_normalized })
    },
    first_name: {
      staticWidth: 150,
      renderCell: (first_name) => /* @__PURE__ */ React.createElement("span", null, first_name)
    },
    last_name: {
      staticWidth: 150,
      renderCell: (last_name) => /* @__PURE__ */ React.createElement("span", null, last_name)
    }
  }
};
const ASSET_TYPE_LABELS = {
  machine: "Machine",
  user: "User",
  group: "Group"
};
const allColumnRenderers = {
  attributes: {
    ...machineColumnRenderers.attributes,
    ...userColumnRenderers.attributes,
    type: {
      staticWidth: 100,
      renderCell: (type) => {
        var _a;
        return /* @__PURE__ */ React.createElement("span", null, (_a = ASSET_TYPE_LABELS[type]) != null ? _a : type);
      }
    }
  }
};
export const columnRenderers = {
  machine: machineColumnRenderers,
  user: userColumnRenderers
};
export const getColumnRenderers = (layoutVariant) => {
  var _a;
  return (_a = columnRenderers[layoutVariant]) != null ? _a : allColumnRenderers;
};
